import { getOneHrCourseProgress } from "api/oneHR";
import Square from "components/Square/Square";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import images from "ressources/images";
import "./OneHrCourseItem.scss";

const OneHrCourseItem = ({ id, title, duration, picture, href }) => {
  const [courseProgress, setcourseProgress] = useState(0);
  const image = picture || images.default_category_bg;

  useEffect(() => {
    getOneHrCourseProgress(id)
      .then((data) => {
        if (data.completed) {
          return setcourseProgress(100);
        }

        if (data.timeSpentOnCourse > 0) {
          setcourseProgress(50);
        }
      })
      .catch((err) => {
        // This should return a 404 if no history is present
        // Right now, we should not do anything if a real error is thrown
      });
  }, []);

  return (
    <a href={href} target={"_blank"}>
      <Square>
        <div
          className="course-item"
          style={{
            backgroundImage: `linear-gradient(
              transparent, #000
              ), url(${image})`,
          }}
        >
          <span className="course-item__icon oneHr course-item__icon__formation"></span>
          {/* <span className="element__points">
          +{coursePoints} <img src={images.points_stars} alt="" />
        </span> */}
          <span className="course-item__title">{title}</span>
          <div className={"course-item__progress__container"}>
            <div className="course-item__progress">
              <div
                className="course-item__progress__bar"
                style={{ width: courseProgress + "%" }}
              ></div>
            </div>
            <div className="formation_time">
              <div className="time">{duration}</div>
            </div>
          </div>
        </div>
      </Square>
    </a>
  );
};

export default OneHrCourseItem;
